import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { KnowledgeManagement } from "@/components/ai-assistant/management/KnowledgeManagement";
import { RulesManagement } from "@/components/ai-assistant/management/RulesManagement";
import { CacheManagement } from "@/components/ai-assistant/management/CacheManagement";
import { MultiLanguageManagement } from "@/components/ai-assistant/management/MultiLanguageManagement";
import { PromptsManagement } from "@/components/ai-assistant/management/PromptsManagement";
import { ConfigurationManagement } from "@/components/ai-assistant/management/ConfigurationManagement";
import { RegexPatternsManagement } from "@/components/ai-assistant/management/RegexPatternsManagement";
import { MessageLimitsManagement } from "@/components/ai-assistant/management/MessageLimitsManagement";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Check } from 'lucide-react';

const AiAssistantManagementPage = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">AI Assistant Management</h1>
        <p className="text-muted-foreground mt-1">Configuration and optimization</p>
      </div>
      
      <Alert className="bg-green-50 border-green-200 dark:bg-green-900/20 dark:border-green-800">
        <Check className="h-4 w-4 text-green-600 dark:text-green-400" />
        <AlertTitle>Multi-language support enabled</AlertTitle>
        <AlertDescription>
          Multi-language content is always used for all conversations to provide the best experience in any language.
        </AlertDescription>
      </Alert>
      
      <Tabs defaultValue="prompts">
        <TabsList className="mb-4">
          <TabsTrigger value="knowledge">Knowledge Base</TabsTrigger>
          <TabsTrigger value="rules">Rules Engine</TabsTrigger>
          <TabsTrigger value="regex">Regex Patterns</TabsTrigger>
          <TabsTrigger value="cache">Cache Management</TabsTrigger>
          <TabsTrigger value="multi-language">Multi-Language</TabsTrigger>
          <TabsTrigger value="configuration">Configuration</TabsTrigger>
          <TabsTrigger value="message-limits">Message Limits</TabsTrigger>
          <TabsTrigger value="prompts">Prompts</TabsTrigger>
        </TabsList>
        
        <TabsContent value="knowledge">
          <KnowledgeManagement />
        </TabsContent>
        
        <TabsContent value="rules">
          <RulesManagement />
        </TabsContent>

        <TabsContent value="regex">
          <RegexPatternsManagement />
        </TabsContent>
        
        <TabsContent value="cache">
          <CacheManagement />
        </TabsContent>
        
        <TabsContent value="multi-language">
          <MultiLanguageManagement />
        </TabsContent>
        
        <TabsContent value="configuration">
          <ConfigurationManagement />
        </TabsContent>
        
        <TabsContent value="message-limits">
          <MessageLimitsManagement />
        </TabsContent>
        
        <TabsContent value="prompts">
          <PromptsManagement />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default AiAssistantManagementPage;
